"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const uom_1 = require("@genesys/uom");
function parse(air) {
    const units = air.map(a => uom_1.Serialize.stringToUnit(a[2].substring(1, a[2].length - 1)));
    const parseAmount = (index) => {
        const unit = units[index];
        if (!unit) {
            throw new Error("Freon: Unknown unit at column index: " + index);
        }
        const value = parseFloat(air[index][1]);
        return uom_1.Serialize.amountToString(uom_1.Amount.create(value, unit));
    };
    return {
        temperatureIn: parseAmount(0),
        humidityIn: parseAmount(1),
        pressureIn: parseAmount(2),
        steamState: {
            steamPressure: parseAmount(3),
            subCooling: parseAmount(4),
            superHeat: parseAmount(5)
        }
    };
}
//# sourceMappingURL=parse-case-steam.js.map